module.exports = __webpack_public_path__ + "img/4_title.d0e4f103.png";